import { Stack } from '@mui/material';
import moment from 'moment';
import { useDispatch } from 'react-redux';

import { setFilteredClaims } from 'core/store/claimsV2Slice';
import { useAppSelector } from 'core/store/hooks';

import {
  PublishedSinceDates,
  SourceDates,
  sortSourcesByDate,
} from 'pages/PlaygroundV2Page/helpers';

import {
  setOpenFilterPopover,
  setSelectedPublishedSinceDate,
  setSelectedSearchEngines,
  setSelectedSourceDate,
} from 'core/store/sourceFilterV2Slice';
import { DARKER_WHITE } from 'utils/theme';
import useFilterActions from '../../useFilterActions';
import FooterButton from './components/FooterButton';

const PopoverFooter = ({ localFilters, setLocalFilters }) => {
  const dispatch = useDispatch();
  const { resetFilters } = useFilterActions();
  const claims = useAppSelector((state) => state.claimsV2.claims);

  const applyFilters = () => {
    const { searchEngines, sourceDate, publishedSince } = localFilters;

    dispatch(setSelectedSearchEngines(searchEngines));

    let filteredClaims = searchEngines.length
      ? claims.map((claim) => ({
          ...claim,
          evidence: claim.evidence?.filter((e) => searchEngines.includes(e.searchEngine ?? '')),
        }))
      : claims;

    if (sourceDate) {
      dispatch(setSelectedSourceDate(sourceDate));
      filteredClaims = filteredClaims.map((claim) => ({
        ...claim,
        evidence: sortSourcesByDate(claim.evidence ?? [], sourceDate),
      }));
    }

    if (publishedSince) {
      dispatch(setSelectedPublishedSinceDate(publishedSince));

      if (publishedSince !== PublishedSinceDates.ANY) {
        const startDate = moment().subtract(publishedSince, 'months');
        filteredClaims = filteredClaims.map((claim) => ({
          ...claim,
          evidence: claim.evidence?.filter((e) => moment(e.publishDate).isAfter(startDate)),
        }));
      }
    }

    dispatch(setFilteredClaims(filteredClaims));
    dispatch(setOpenFilterPopover(false));
  };

  const resetAllFilters = () => {
    setLocalFilters({
      searchEngines: [],
      sourceDate: SourceDates.MOST_RECENT,
      publishedSince: PublishedSinceDates.ANY,
    });

    resetFilters();
    dispatch(setOpenFilterPopover(false));
  };

  return (
    <Stack direction="row" spacing={1} position="relative" left="70px" pt={2} pb={3}>
      <FooterButton onClick={applyFilters} background={DARKER_WHITE}>
        Apply
      </FooterButton>
      <FooterButton onClick={resetAllFilters} border={`1px solid ${DARKER_WHITE}`}>
        Clear All
      </FooterButton>
    </Stack>
  );
};

export default PopoverFooter;
